// extracted by mini-css-extract-plugin
export default {"news-feed":"NewsFeed_news-feed__2pW8I","news-feed__title":"NewsFeed_news-feed__title__L1Knp"};